import { InvoiceList } from "./InvoiceList";
import { InvoiceShow } from "./InvoiceShow";
import { InvoiceCreate } from "./InvoiceCreate";

export default {
  list: InvoiceList,
  show: InvoiceShow,
  create: InvoiceCreate,
};
